module.exports = __webpack_public_path__ + "static/img/sox3.78f46f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/furnitures/sox3.jpg
// module id = BQGS
// module chunks = 0